import { render, staticRenderFns } from "./RentValidator.vue?vue&type=template&id=b2b11aa2"
import script from "./RentValidator.vue?vue&type=script&lang=js"
export * from "./RentValidator.vue?vue&type=script&lang=js"
import style0 from "./RentValidator.vue?vue&type=style&index=0&id=b2b11aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports